/** Desktop diagram: stały laptop 855×502; strzałki SVG przy kartach. */
export const DIAGRAM_DESKTOP_MIN_PX = 1156;

export const LAPTOP_W = 855;
export const LAPTOP_H = 502;
export const LAPTOP_HALF_W = LAPTOP_W / 2;
export const LAPTOP_HALF_H = LAPTOP_H / 2;

/** Odstęp górna/dolna karta ↔ krawędź obrazka laptopa (desktop). */
export const CARD_TO_LAPTOP_GAP_PX = 24;

/** Szerokość karty `LandingInfoCard` + `desktopSpec` (Reasons). */
export const CARD_DESKTOP_W = 342;

/** Tylko kolumna Prezentacje (`diagramColLeft`, desktop diagram) — wyrównanie strzałki do laptopa. Prawa kolumna bez tego offsetu. */
export const PREZENTACJE_COLUMN_OFFSET_LEFT_PX = 100;

/** Maks. szerokość bloku tytuł + opis w kartach diagramu poniżej `md` (`contentMaxWidthMobileOnly`). */
export const CARD_TEXT_CONTENT_MAX_PX = 166;

/** Górna / dolna karta: lewa krawędź na 1/5 szerokości obrazka od lewej krawędzi laptopa. */
export const CARD_LEFT_AT_IMG_FIFTH = LAPTOP_W / 5;

/** Szacowana wysokość bloku karty Research (tytuł+opis) — do wyrównania góra/dół względem laptopa. */
export const RESEARCH_CARD_BLOCK_APPROX_H_PX = 220;

/** Odsunięcie strzałek od krawędzi karty — ok. padding `LandingInfoCard` (`p(3,2)` itd.). */
export const ARROW_CARD_PADDING_INSET_PX = 28;

/** Korekta pozycji strzałek względem insetu: research w dół, monitoring w prawo, prezentacje w górę. */
export const ARROW_NUDGE_PX = 16;

/** Układ mobilny: `max-width` = poniżej progu desktopu. */
export const DIAGRAM_MOBILE_MAX_PX = DIAGRAM_DESKTOP_MIN_PX - 1;

/** Skalowanie eksportów Arrow 4 / 7 / 8 na mobile (rozmiar `span` w `BigDataHowItWorksDiagramArrows`). */
export const DIAGRAM_MOBILE_ARROW_ASSET_SCALE = 2.15;

/** Eksportowane SVG mobilnych strzałek (viewBox — proporcje img). */
export const ARROW_4_NATURAL_W_PX = 20;
export const ARROW_4_NATURAL_H_PX = 78;
export const ARROW_7_NATURAL_W_PX = 6;
export const ARROW_7_NATURAL_H_PX = 277;
export const ARROW_8_NATURAL_W_PX = 27;
export const ARROW_8_NATURAL_H_PX = 77;

/** Rozmiary strzałek SVG (powiększone względem eksportu — żeby mostek sięgał laptopa). */
export const ARROW_RESEARCH_W = 232;
export const ARROW_RESEARCH_H = 106;
export const ARROW_PREZENTACJE_W = 117;
export const ARROW_PREZENTACJE_H = 51;
export const ARROW_MONITORING_W = 228;
export const ARROW_MONITORING_H = 103;

export const ARROW_7_MOBILE_HEIGHT_PX = 265;
